import React from "react"
import Logo from "../../icons/dp_logo.svg"
import { createUseStyles } from "react-jss"
import { useTheme } from "@emotion/react"
import { Typography } from "@mui/material"
import { SignOutButton } from "../SignOutButton"
import WelcomeName from "../WelcomeName"

const useStyles = createUseStyles({
  wrapper: {
    height: "58px",
    background: "var(--primary-dp-color)",
    alignItems: "center",
    display: "flex",
    flexGrow: 1,
  },
  headerWrapper: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
  },
  logo: {
    marginLeft: "5px",
    height: "43px",
    backgroundColor: "var(--background-white-color)",
  },
  header: {
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    letterSpacing: "0em",
    textAlign: "left",
    color: "#000000",
    textTransform: "uppercase",
    marginLeft: "10px", // Added margin for spacing between the logo and text
  },
})

export default function Header() {
  const theme = useTheme()
  const classes = useStyles({ theme })

  return (
    <div className={classes.wrapper}>
      <Typography className={classes.headerWrapper}>
        <img src={Logo} alt="" className={classes.logo} />
        <h2 className={classes.header}>Command Center</h2>
      </Typography>
      <WelcomeName />
      <SignOutButton />
    </div>
  )
}
